import actionTypes from '../actionTypes';

export function requestLeaderBoard( credentials ) {
  return {
    type: actionTypes.LEADERBOARD_REQUEST,
    credentials
  };
}

export function successLeaderBoard( {leaderboard, header} ) {
  return {
    type: actionTypes.LEADERBOARD_SUCCESS,
    leaderboard,
    header
  };
}

export function failureLeaderBoard() {
  return {
    type: actionTypes.LEADERBOARD_FAILURE
  };
}